import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { axiosAPI } from '@/services/axiosInstance/axipsInstansce';
import VerificationInput from 'react-verification-input';
import classNames from 'classnames';
import { SVGUnion } from '@/images/svg/svg-icons';
import Loading from '@/components/Loading/Loading';
export interface Step2Props {
  valuePhone: string;
  valueMail: string;
  isLoadingVerify: boolean;
  setIsLoadingVerify: Dispatch<SetStateAction<boolean>>;
  setEmail: Dispatch<SetStateAction<string>>;
  onSuccess: any;

  position: string;
  location: string[];
}
export default function Step2({
  valuePhone,
  valueMail,
  isLoadingVerify,
  setIsLoadingVerify,
  setEmail,
  onSuccess,
  position,
  location,
}: Step2Props) {
  const [countdown, setCountdown] = useState(59);
  const [valueCode, setValueCode] = useState('');
  const [isCodeError, setIsCodeError] = useState(false);

  useEffect(() => {
    if (countdown != 0) {
      setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
  }, [countdown]);

  async function onResend() {
    if (!!valuePhone.trim() && !!valueMail.trim()) {
      setIsLoadingVerify(true);
      try {
        await axiosAPI
          .post('verification/re-send-confirmation', {
            mobile: `+1${valuePhone}`,
            email: valueMail,
          })
          .then(() => {
            setIsLoadingVerify(false);
            setCountdown(59);
          });
      } catch (error: any) {
        setIsLoadingVerify(false);
        setCountdown(59);
        console.log(error);
      }
    }
  }

  async function onVerify() {
    if (!!valueCode.trim()) {
      try {
        setIsLoadingVerify(true);

        await axiosAPI
          .post('verification/verify-code', {
            mobile: `+1${valuePhone}`,
            email: valueMail,
            code: valueCode,
            jobPosition: position,
            location: location?.length === 1 ? location[0] : 'all',
          })
          .then((res: any) => {
            setIsLoadingVerify(false);
            if (!res.data.valid) {
              setIsCodeError(true);
            } else {
              setEmail(valueMail);
              setIsCodeError(false);
              setValueCode('');
              onSuccess();
            }
          });
      } catch (error: any) {
        setIsLoadingVerify(false);
        setIsCodeError(true);
      }
    }
  }

  function onChange(e: string) {
    setIsCodeError(false);
    setValueCode(e);
  }

  useEffect(() => {
    if (valueCode.length === 6) {
      onVerify().then();
    }
  }, [valueCode]);

  return (
    <div className={classNames(isLoadingVerify && 'pointer-events-none')}>
      {isLoadingVerify && <Loading />}
      <p className='text-main-black text-base p-4'>
        Please, enter the 6-digit code sent to <br />
        +1{valuePhone} by SMS.
      </p>
      <div
        className={classNames(
          'p-4 flex justify-center relative',
          isCodeError && 'code-error'
        )}
      >
        {isCodeError && (
          <div className='absolute -top-3 w-full flex justify-center'>
            <div className='h-4 w-4 mr-2'>
              <SVGUnion />
            </div>
            <p className='text-main-error text-sm'>
              The verification code does not match
            </p>
          </div>
        )}
        <VerificationInput
          autoFocus
          placeholder={''}
          validChars='0-9'
          value={valueCode}
          onChange={(e: string) => onChange(e)}
          inputProps={{ inputMode: 'numeric' }}
        />
      </div>
      <div>
        {countdown > 0 ? (
          <p className='text-main-neutrals text-center text-base px-1 py-3'>
            Resend code in 00:{countdown < 10 && '0'}
            {countdown}
          </p>
        ) : (
          <p
            className={
              'cursor-pointer text-main-blue text-center text-base px-1 py-3'
            }
            onClick={onResend}
          >
            Resend code
          </p>
        )}
      </div>
    </div>
  );
}
